import { render, staticRenderFns } from "./DialogNewConversation.vue?vue&type=template&id=76cb86c4&"
import script from "./DialogNewConversation.vue?vue&type=script&lang=js&"
export * from "./DialogNewConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports